import { lowerCase, round } from 'lodash-es';
import { percent } from '@perch-labs/warbler';
import { FuelTypeEquivalency } from 'hooks/use-impact-stats.hook';

export const getStats = (
  fuelTypeEquivalency: FuelTypeEquivalency,
  energyBreakdown: GetGridStatsQuery['egridSubregion']['energyBreakdown'],
  energySource: string
) => {
  const source = energySource === 'gas' ? 'naturalGas' : energySource;
  return {
    equivalency: round(fuelTypeEquivalency[source].equivalency, 2),
    percent: percent(energyBreakdown[energySource], 1),
    units: lowerCase(fuelTypeEquivalency[source].units),
  };
};
